import { render, staticRenderFns } from "./LatestTweetsWidget.vue?vue&type=template&id=816c65da&"
import script from "./LatestTweetsWidget.vue?vue&type=script&lang=js&"
export * from "./LatestTweetsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports